var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@hn-ui/tooltips';
import { TestTooltipContent } from './TooltipContent';
import { ActivityDayContainer } from '../ActivityDayContainer';
var DayLabel = {
    primary: 'PT',
    middle: 'MT',
    finally: 'ET',
};
var TestDay = function (_a) {
    var isModalOpen = _a.isModalOpen, type = _a.type, status = _a.status, contentProps = _a.contentProps;
    var isActive = !(status === 'canceled' || status === 'expired');
    return (_jsx(Tooltip, __assign({ maxWidth: 450, interactive: !isModalOpen, content: _jsx(TestTooltipContent, __assign({}, contentProps), void 0) }, { children: _jsx(ActivityDayContainer, __assign({ "$isActive": isActive }, { children: DayLabel[type] }), void 0) }), void 0));
};
export { TestDay };
